import { List, ListItem, ListItemText } from '@material-ui/core';
import AdapterLink from 'components/AdapterLink';
import React from 'react';

export default () => {
  const items = [
    { path: `/docs/about`, text: `About the Fragment Network` },
    { path: `/docs/whatsNovel`, text: `What's novel about Fragnet Search` },
    { path: `/docs/userDocs`, text: `Fragnet Search user documentation` },
    { path: `/docs/fragnetGeneration`, text: `How the fragment network is generated` },
  ];

  return (
    <List component="nav" aria-label="main mailbox folders">
      {items.map(({ path, text }) => (
        <React.Fragment key={path}>
          <ListItem
            selected={window.location.pathname === path}
            button
            component={AdapterLink}
            to={path}
          >
            <ListItemText primary={text} />
          </ListItem>
        </React.Fragment>
      ))}
    </List>
  );
};
